import { Link, LinkProps } from 'react-router-dom';
import { ContactOrCompanyLabel } from 'assets/js/pages/contacts/ContactOrCompanyLabel';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { twMerge } from 'tailwind-merge';
import { SoftCredit } from 'types/domain';

interface SoftCreditLinkProps extends Omit<LinkProps, 'to'> {
    softCredit: SoftCredit;
}

const SoftCreditLink = ({ softCredit, className, ...rest }: SoftCreditLinkProps) => {
    const { accountId } = useCurrentAccount();
    const urlResource = softCredit.contact.type === ContactType.Company ? 'companies' : 'contacts';
    return (
        <Link
            className={twMerge(className)}
            to={`/accounts/${accountId}/${urlResource}/${softCredit.contact.id}`}
            {...rest}
        >
            <ContactOrCompanyLabel contact={softCredit.contact} />
        </Link>
    );
};

export { SoftCreditLink };
